// @flow

export const SET_PROMPTS = 'set:Prompts';
export const SET_EDITOR_ID = 'set:editorid';
export const SET_API_CALL_IN_PROGRESS = 'set:apicallInProgress';
export const SET_IMAGE_UPLOADING_IN_PROGRESS = 'set:ImageUploadingInProgress';
